import { useContext } from 'react'
import { computed } from 'mobx'
import { schema } from 'prose-core'

import { changeIndentation, INDENT_DIRECTION } from 'common/Prose/Commands'
import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'
import { ButtonHook } from 'common/Prose/Toolbar/Types'
import { AlmanacEditorStateContext } from 'stores/EditorState'

export function useIndentInToggle(): ButtonHook {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const almanacState = useContext(AlmanacEditorStateContext)!

  const view = useEditorView()

  const hasCodeBlock = computed(() => almanacState.activeNodes.has(schema.nodes.code_block)).get()

  const handleClick = () => {
    const command = changeIndentation(INDENT_DIRECTION.INDENT)
    command(view.state, view.dispatch)
  }

  return { active: false, handleClick: handleClick, disabled: hasCodeBlock }
}
